'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NavbarBrand = require('react-bootstrap/lib/NavbarBrand');

var _NavbarBrand2 = _interopRequireDefault(_NavbarBrand);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NavbarBrand2.default;